const BASIC_URL = "https://api-lv.language-village.org/api";
// const BASIC_URL = "http://127.0.0.1:8092/api";
// const BASIC_URL = "http://192.168.43.223:8085/api";

const NestApi = "https://nest-lv.language-village.org";
// const NestApi = "http://127.0.0.1:4000";
// const NestApi = "http://192.168.43.223:4000";

// const apiKeyStream = "gh3kbcffgsrf";
const apiKeyStream = "zkcj2nm68drf";
const ExamsAppUrl = "https://exams.language-village.org";
// const ExamsAppUrl = "http://localhost:3002";

const Config = {
  api: {
    examsAppUrl: ExamsAppUrl,
    nestapi: `${NestApi}`,
    ApiKeyStream: {
      api: `${apiKeyStream}`,
    },
    Admin: {
      Login: `${BASIC_URL}/auth/login`,
      logout: `${BASIC_URL}/auth/logout`,
      register: `${BASIC_URL}/auth/register`,
      verify_code: `${BASIC_URL}/auth/verify-code`,
      reSendCode: `${BASIC_URL}/auth/reSendCode`,
      redirect: `${BASIC_URL}/auth/redirect`,
      Password_change: `${BASIC_URL}/auth/password/change`,
      profile_update: `${BASIC_URL}/v1/cms/profile/update`,
      v1_profile: `${BASIC_URL}/v1/profile`,
      profile: `${BASIC_URL}/v1/profile`,
      forgetPassword: `${BASIC_URL}/auth/password/forgot`,
      checkToken: `${BASIC_URL}/auth/password/checkToken`,
      resetPassword: `${BASIC_URL}/auth/password/reset`,
      validateToken: `${BASIC_URL}/auth/validate`,
    },
    Exposed: {
      allCategories: `${BASIC_URL}/app/exposed/allCategories`,
      allCourses: `${BASIC_URL}/app/exposed/allCourses`,
      courseDetails: `${BASIC_URL}/app/exposed/courseDetails`,
    },
    Notifications: {
      allNotifications: `${BASIC_URL}/app/notifications/all`,
      numberUnClickedNotification: `${BASIC_URL}/app/notifications/numberUnClickedNotification`,
      notificationStatusUpdate: `${BASIC_URL}/app/notifications/notificationStatusUpdate`,
      deleteNotification: `${BASIC_URL}/app/notifications/delete`,
      deleteAllNotification: `${BASIC_URL}/app/notifications/deleteAll`,
    },
    Users: {
      users_actions_verifyAccount: `${BASIC_URL}/app/users/actions/verifyAccount`,
      app_users_actions_updatePassword: `${BASIC_URL}/app/users/actions/updatePassword`,
      app_users_actions_update2FA: `${BASIC_URL}/app/users/actions/update2FA`,
      auth_verify_2fa: `${BASIC_URL}/auth/verify-2fa`,
      app_users_actions_updateUserInfo: `${BASIC_URL}/app/users/actions/updateUserInfo`,
      app_users_allUsers: `${BASIC_URL}/app/users/allUsers`,
      userDetails: `${BASIC_URL}/app/users/get`,
      app_users_add: `${BASIC_URL}/app/users/add`,
      app_users_update: `${BASIC_URL}/app/users/update`,
      app_users_delete: `${BASIC_URL}/app/users/delete`,
      app_users_export_to_excel: `${BASIC_URL}/app/users/export`,
      // Blacklist endpoints
      app_blacklist_all: `${BASIC_URL}/app/users/blackListed/all`,
      app_blacklist_add: `${BASIC_URL}/app/users/blackListed/add`,
      app_blacklist_delete: `${BASIC_URL}/app/users/blackListed/delete`,
    },
    Courses: {
      app_courses_all: `${BASIC_URL}/app/courses/all`,
      app_courses_get: `${BASIC_URL}/app/courses/get`,
      app_courses_add: `${BASIC_URL}/app/courses/add`,
      app_courses_delete: `${BASIC_URL}/app/courses/delete`,
      app_courses_update: `${BASIC_URL}/app/courses/update`,
      app_courses_export_to_excel: `${BASIC_URL}/app/courses/export`,
      app_courses_allLessonsForCourse: `${BASIC_URL}/app/courses/allLessonsForCourse`,
      app_courses_allPaymentsForCourse: `${BASIC_URL}/app/courses/allPaymentsForCourse`,
      app_courses_allStudentsCourse: `${BASIC_URL}/app/courses/allStudentsForCourse`,
      app_instructors_allCoursesAssignedToInstructor: `${BASIC_URL}/app/instructors/allCoursesAssignedToInstructor`,
      app_courses_changeStatusForCourse: `${BASIC_URL}/app/courses/changeStatusForCourse`,
      // lessons
      app_courses_lessons_all: `${BASIC_URL}/app/courses/lessons/all`,
      app_courses_lessons_get: `${BASIC_URL}/app/courses/lessons/get`,
      app_courses_lessons_add: `${BASIC_URL}/app/courses/lessons/add`,
      app_courses_lessons_update: `${BASIC_URL}/app/courses/lessons/update`,
      app_courses_lessons_delete: `${BASIC_URL}/app/courses/lessons/delete`,
      app_courses_lessons_export_to_excel: `${BASIC_URL}/app/courses/lessons/export`,
      app_courses_lessons_changeStatusForLesson: `${BASIC_URL}/app/courses/lessons/changeStatusForLesson`,
      app_courses_lessons_getLessonByRoomUUID: `${BASIC_URL}/app/courses/lessons/getLessonByRoomUUID`,
      // Live and Chat
      app_courses_chat_allMessagesForRoom: `${BASIC_URL}/app/courses/chat/allMessagesForRoom`,
      app_courses_chat_createRoom: `${BASIC_URL}/app/courses/chat/createRoom`,
      app_courses_chat_sendMessage: `${BASIC_URL}/app/courses/chat/sendMessage`,
      app_courses_chat_changeRoomStatus: `${BASIC_URL}/app/courses/chat/changeRoomStatus`,
      app_courses_live_startLive: `${BASIC_URL}/app/courses/lessons/live/startLive`,
      app_courses_live_endLive: `${BASIC_URL}/app/courses/lessons/live/endLive`,
      app_courses_live_joinLive: `${BASIC_URL}/app/courses/lessons/live/joinLive`,
      app_courses_live_records_all: `${BASIC_URL}/app/courses/lessons/live/recordings/all`,
      app_courses_live_records_download: `${BASIC_URL}/app/courses/lessons/live/recordings/downloadRecords`,
      app_courses_live_set_recording_layout: `${NestApi}/live/setRecordingLayout`,
      // live records

      Lessons: {
        getLesson: `${BASIC_URL}/app/courses/lessons/get`,
      },
    },
    Categories: {
      app_categories_all: `${BASIC_URL}/app/categories/all`,
      app_categories_get: `${BASIC_URL}/app/categories/get`,
      app_categories_add: `${BASIC_URL}/app/categories/add`,
      app_categories_update: `${BASIC_URL}/app/categories/update`,
      app_categories_delete: `${BASIC_URL}/app/categories/delete`,
      app_categories_export_to_excel: `${BASIC_URL}/app/categories/export`,
    },
    Roles: {
      app_roles_all: `${BASIC_URL}/app/roles/all`,
      app_roles_add: `${BASIC_URL}/app/roles/add`,
      app_roles_delete: `${BASIC_URL}/app/roles/delete`,
      app_roles_get: `${BASIC_URL}/app/roles/get`,
      app_roles_getUsersByRole: `${BASIC_URL}/app/roles/getUsersByRole`,
      app_roles_giveRoleToUser: `${BASIC_URL}/app/roles/giveRoleToUser`,
      app_roles_removeRoleFromUser: `${BASIC_URL}/app/roles/detachRoleFromUser`,
      app_roles_assignTemporaryRole: `${BASIC_URL}/app/roles/assignTemporaryRole`,
      app_roles_givePermissionToRole: `${BASIC_URL}/app/roles/givePermissionToRole`,
      app_roles_permissions_all: `${BASIC_URL}/app/roles/permissions/all`,
      app_roles_permissions_get: `${BASIC_URL}/app/roles/permissions/get`,
      app_roles_permissions_add: `${BASIC_URL}/app/roles/permissions/add`,
      app_roles_permissions_delete: `${BASIC_URL}/app/roles/permissions/delete`,
    },
    Instructors: {
      app_instructors_all: `${BASIC_URL}/app/instructors/all`,
      app_instructors_get: `${BASIC_URL}/app/instructors/get`,
      app_instructors_add: `${BASIC_URL}/app/instructors/add`,
      app_instructors_update: `${BASIC_URL}/app/instructors/update`,
      app_instructors_delete: `${BASIC_URL}/app/instructors/delete`,
      app_instructors_export_to_excel: `${BASIC_URL}/app/instructors/export`,
      app_instructors_allCoursesAssignedToInstructor: `${BASIC_URL}/app/instructors/allCoursesAssignedToInstructor`,
      app_instructors_changePresentForInstructor: `${BASIC_URL}/app/instructors/changePresentForInstructor`,
    },
    Students: {
      app_students_all: `${BASIC_URL}/app/students/all`,
      app_students_get: `${BASIC_URL}/app/students/get`,
      app_students_add: `${BASIC_URL}/app/students/add`,
      app_students_update: `${BASIC_URL}/app/students/update`,
      app_students_delete: `${BASIC_URL}/app/students/delete`,
      app_students_export_to_excel: `${BASIC_URL}/app/students/export`,
      app_students_allCoursesForStudent: `${BASIC_URL}/app/students/allCoursesForStudent`,
      app_students_allStudentPayments: `${BASIC_URL}/app/students/allStudentPayments`,
      app_students_changePresentForStudent: `${BASIC_URL}/app/students/changePresentForStudent`,
    },
    Enrollment: {
      // enrollment
      app_enrollment_enrollStudent: `${BASIC_URL}/app/enrollment/enrollStudent`,
      app_enrollment_getAllStudentsForCourse: `${BASIC_URL}/app/enrollment/getAllStudentsForCourse`,
      app_enrollment_enrollStudentToCourse: `${BASIC_URL}/app/enrollment/enrollStudentToCourse`,
      app_enrollment_removeStudentFromCourse: `${BASIC_URL}/app/enrollment/removeStudentFromCourse`,
    },
    Payments: {
      app_courses_payments_all: `${BASIC_URL}/app/courses/payments/all`,
      app_courses_payments_get: `${BASIC_URL}/app/courses/payments/get`,
      app_courses_payments_add: `${BASIC_URL}/app/courses/payments/add`,
      app_courses_payments_update: `${BASIC_URL}/app/courses/payments/update`,
      app_courses_payments_delete: `${BASIC_URL}/app/courses/payments/delete`,
      app_courses_payments_export_to_excel: `${BASIC_URL}/app/courses/payments/excel`,
      app_courses_payments_changeStatusForPayment: `${BASIC_URL}/app/courses/payments/changeStatusForPayment`,
    },
    Materials: {
      app_courses_materials_all: `${BASIC_URL}/app/courses/materials/all`,
      app_courses_materials_get: `${BASIC_URL}/app/courses/materials/get`,
      app_courses_materials_add: `${BASIC_URL}/app/courses/materials/add`,
      app_courses_materials_delete: `${BASIC_URL}/app/courses/materials/delete`,
      app_courses_materials_download: `${BASIC_URL}/app/courses/materials/downloadMaterial`,
      app_courses_materials_export_to_excel: `${BASIC_URL}/app/courses/materials/export`,
      app_courses_materials_getMaterialByUuid: `${BASIC_URL}/app/courses/materials/getMaterialByUuid`,
      app_courses_materials_allMaterialsForCourse: `${BASIC_URL}/app/courses/materials/allMaterialsForCourse`,
    },
    Webhooks: {
      download_files_from_stream_io: `${BASIC_URL}/app/courses/lessons/live/recordings/downloadFromSource`,
    },
    Refunds: {
      app_courses_payments_refund_all: `${BASIC_URL}/app/courses/payments/refund/all`,
      app_courses_payments_refund_get: `${BASIC_URL}/app/courses/payments/refund/get`,
      app_courses_payments_refund_add: `${BASIC_URL}/app/courses/payments/refund/add`,
      app_courses_payments_refund_update: `${BASIC_URL}/app/courses/payments/refund/update`,
      app_courses_payments_refund_delete: `${BASIC_URL}/app/courses/payments/refund/delete`,
      app_courses_payments_refund_export_to_excel: `${BASIC_URL}/app/courses/payments/refund/export`,
    },
    Dashboard: {
      app_statistics_countOfData: `${BASIC_URL}/app/dashboard/stats/countOfData`,
      app_statistics_statsDataForInstructor: `${BASIC_URL}/app/dashboard/stats/statsDataForInstructor`,
      app_statistics_statsDataForStudent: `${BASIC_URL}/app/dashboard/stats/statsDataForStudent`,
    },
    Activity: {
      app_activity_pingUserOnline: `${BASIC_URL}/app/activity/ping`,
      app_activity_markOffLine: `${BASIC_URL}/app/activity/markOffLine`,
    },
    Blog: {
      Categories: {
        app_blog_categories_all: `${BASIC_URL}/app/blog/categories/all`,
        app_blog_categories_get: `${BASIC_URL}/app/blog/categories/get`,
        app_blog_categories_add: `${BASIC_URL}/app/blog/categories/add`,
        app_blog_categories_update: `${BASIC_URL}/app/blog/categories/update`,
        app_blog_categories_delete: `${BASIC_URL}/app/blog/categories/delete`,
        app_blog_categories_allPostsCategory: `${BASIC_URL}/app/blog/categories/allPostsCategory`,
      },
      Posts: {
        app_blog_categories_posts_all: `${BASIC_URL}/app/blog/categories/posts/all`,
        app_blog_categories_posts_get: `${BASIC_URL}/app/blog/categories/posts/get`,
        app_blog_categories_posts_add: `${BASIC_URL}/app/blog/categories/posts/add`,
        app_blog_categories_posts_update: `${BASIC_URL}/app/blog/categories/posts/update`,
        app_blog_categories_posts_delete: `${BASIC_URL}/app/blog/categories/posts/delete`,
        app_blog_categories_posts_allCommentsOnPost: `${BASIC_URL}/app/blog/categories/posts/allCommentsOnPost`, // post_id
        app_blog_categories_posts_allReactionsOnPost: `${BASIC_URL}/app/blog/categories/posts/allReactionsOnPost`, // post_id
        app_blog_categories_posts_reportPost: `${BASIC_URL}/app/blog/categories/posts/reportPost`, // post_id
      },
      Comments: {
        app_blog_categories_posts_comments_all: `${BASIC_URL}/app/blog/categories/posts/comments/all`,
        app_blog_categories_posts_comments_get: `${BASIC_URL}/app/blog/categories/posts/comments/get`,
        app_blog_categories_posts_comments_add: `${BASIC_URL}/app/blog/categories/posts/comments/add`,
        app_blog_categories_posts_comments_update: `${BASIC_URL}/app/blog/categories/posts/comments/update`,
        app_blog_categories_posts_comments_delete: `${BASIC_URL}/app/blog/categories/posts/comments/delete`,
        app_blog_categories_posts_comments_allReactionsOnComment: `${BASIC_URL}/app/blog/categories/posts/comments/allReactionsOnComment`, // comment_id
        app_blog_categories_posts_comments_reportComment: `${BASIC_URL}/app/blog/categories/posts/comments/reportComment`, // comment_id
      },
      Reactions: {
        app_blog_categories_posts_addReactionOnPost: `${BASIC_URL}/app/blog/categories/posts/reactions/addReactionOnPost`, // post_id
        app_blog_categories_posts_removeReactionOnPost: `${BASIC_URL}/app/blog/categories/posts/reactions/removeReactionOnPost`, // post_id
        app_blog_categories_posts_addReactionOnComment: `${BASIC_URL}/app/blog/categories/posts/reactions/addReactionOnComment`, // comment_id
        app_blog_categories_posts_removeReactionOnComment: `${BASIC_URL}/app/blog/categories/posts/reactions/removeReactionOnComment`, // comment_id
      },
    },
    // Enhanced Grading and Course Completion
    Exams: {
      all: `${BASIC_URL}/app/exams/all`,
      // Course Completion - Finalize course grading and generate final results
      completeCourse: (courseId) => `${BASIC_URL}/app/exams/completion/complete-course/${courseId}`,
      getCourseCompletionStatus: (courseId) => `${BASIC_URL}/app/exams/completion/status/${courseId}`,
      getCourseResults: (courseId) => `${BASIC_URL}/app/exams/completion/results/${courseId}`,

      // Exam Attempts
      finishExam: `${BASIC_URL}/app/exams/attempts/finish-exam`,
      finalizeGrading: `${BASIC_URL}/app/exams/attempts/finalize-grading`,
      joinExam: `${BASIC_URL}/app/exams/attempts/join-exam`,

      // Student Scores  
      getAllScores: `${BASIC_URL}/app/exams/scores/all`,
      getScoresByStudent: (studentId) => `${BASIC_URL}/app/exams/scores/student/${studentId}`,
      getScoresByCourse: (courseId) => `${BASIC_URL}/app/exams/scores/course/${courseId}`,
      getScoresByExam: (examId) => `${BASIC_URL}/app/exams/scores/exam/${examId}`,
    },
    PlacementTests: {
      all: `${BASIC_URL}/app/placement-tests/all`,
      get: `${BASIC_URL}/app/placement-tests/get`,
      resolveLink: `${BASIC_URL}/app/placement-tests/link`,
      add: `${BASIC_URL}/app/placement-tests/add`,
      update: `${BASIC_URL}/app/placement-tests/update`,
      delete: `${BASIC_URL}/app/placement-tests/delete`,
      enroll: `${BASIC_URL}/app/placement-tests/enroll`,
      startPayment: `${BASIC_URL}/app/placement-tests`,
      approveEnrollment: `${BASIC_URL}/app/placement-tests/approve-enrollment`,
      updatePaymentStatus: `${BASIC_URL}/app/placement-tests`,
      myTests: `${BASIC_URL}/app/placement-tests/my-tests`,
    },
  },
};
export const API = Config.api;
